import styled from 'styled-components';
import {
  background,
  border,
  color,
  layout,
  position,
  shadow,
  space,
  typography,
} from 'styled-system';

export const StyledInput = styled.input`
  cursor: ${props => (props.pointer ? 'pointer' : '')};
  outline: none;

  ${color}
  ${border}
  ${typography}
  ${layout}
  ${space}
  ${shadow}
  ${background}
  ${position}
`;
